// extracted by mini-css-extract-plugin
module.exports = {"hint":"Info_hint__3FRDX","pulsate":"Info_pulsate__3w2_B"};